import { createAction } from '@reduxjs/toolkit';

import {
    ICreateEvent,
    IEventFilter,
    IFilterEvents,
    IGetEventDetails,
    IGetEvents,
    IGetSimilarEvents,
    IPurchaseTicket,
    IUpdateEvent,
    IGetManageEvent,
    types,
    ICreateDiscountCode,
    IUpdateDiscount,
    ICancelEvent,
    IGetEventInviteDetails,
    IAcceptEventInvite,
} from './types';
import { IEvent, IGenericDocumentModifier, IReedemableCode, ITicket } from '../../types/global/helper';
import { IErrorType } from '../../constants/types';

export const getEvents = createAction<IGetEvents>(types.GET_EVENTS);
export const getEventsSuccess = createAction<IEvent[]>(types.GET_EVENTS_SUCCESS);
export const getEventsFail = createAction<IErrorType>(types.GET_EVENTS_FAIL);

export const getEventsDetails = createAction<IGetEventDetails>(types.GET_EVENT_DETAILS);
export const getEventsDetailsSuccess = createAction<IEvent>(types.GET_EVENT_DETAILS_SUCCESS);
export const getEventsDetailsFail = createAction<IErrorType>(types.GET_EVENT_DETAILS_FAIL);

export const createEvent = createAction<ICreateEvent>(types.CREATE_EVENT);
export const createEventSuccess = createAction<IEvent>(types.CREATE_EVENT_SUCCESS);
export const createEventFail = createAction<IErrorType>(types.CREATE_EVENT_FAIL);

export const updateEvent = createAction<IUpdateEvent>(types.UPDATE_EVENT);
export const updateEventSuccess = createAction<IEvent>(types.UPDATE_EVENT_SUCCESS);
export const updateEventFail = createAction<IErrorType>(types.UPDATE_EVENT_FAIL);

export const deleteEvent = createAction<IGenericDocumentModifier>(types.DELETE_EVENT);
export const deleteEventSuccess = createAction<IGenericDocumentModifier>(types.DELETE_EVENT_SUCCESS);
export const deleteEventFail = createAction<IErrorType>(types.DELETE_EVENT_FAIL);

export const publishEvent = createAction<IGenericDocumentModifier>(types.PUBLISH_EVENT);
export const publishEventSuccess = createAction<IEvent>(types.PUBLISH_EVENT_SUCCESS);
export const publishEventFail = createAction<IErrorType>(types.PUBLISH_EVENT_FAIL);

export const unpublishEvent = createAction<IGenericDocumentModifier>(types.UNPUBLISH_EVENT);
export const unpublishEventSuccess = createAction<IEvent>(types.UNPUBLISH_EVENT_SUCCESS);
export const unpublishEventFail = createAction<IErrorType>(types.UNPUBLISH_EVENT_FAIL);

export const approveEvent = createAction<IGenericDocumentModifier>(types.APPROVE_EVENT);
export const approveEventSuccess = createAction<IEvent>(types.APPROVE_EVENT_SUCCESS);
export const approveEventFail = createAction<IErrorType>(types.APPROVE_EVENT_FAIL);

export const purchaseTicket = createAction<IPurchaseTicket>(types.PURCHASE_TICKET);
export const purchaseTicketSuccess = createAction<ITicket>(types.PURCHASE_TICKET_SUCCESS);
export const purchaseTicketFail = createAction<IErrorType>(types.PURCHASE_TICKET_FAIL);

export const getSimilarEvents = createAction<IGetSimilarEvents>(types.GET_SIMILAR_EVENTS);
export const getSimilarEventsSuccess = createAction<IEvent[]>(types.GET_SIMILAR_EVENTS_SUCCESS);
export const getSimilarEventsFail = createAction<IErrorType>(types.GET_SIMILAR_EVENTS_FAIL);

export const setEventFilter = createAction<IEventFilter | undefined>(types.SET_EVENT_FILTER);

export const filterEvents = createAction<IFilterEvents>(types.FILTER_EVENTS);
export const filterEventsSuccess = createAction<IEvent[]>(types.FILTER_EVENTS_SUCCESS);
export const filterEventsFail = createAction<IErrorType>(types.FILTER_EVENTS_FAIL);

export const getManageEvent = createAction<IGetManageEvent>(types.GET_MANAGE_EVENT);
export const getManageEventSuccess = createAction<any>(types.GET_MANAGE_EVENT_SUCCESS);
export const getManageEventFail = createAction<IErrorType>(types.GET_MANAGE_EVENT_FAIL);
export const clearManageEventError = createAction(types.CLEAR_MANAGE_EVENT_ERROR);

export const createDiscountCode = createAction<ICreateDiscountCode>(types.CREATE_DISCOUNT_CODE);
export const createDiscountCodeSuccess = createAction<IReedemableCode>(types.CREATE_DISCOUNT_CODE_SUCCESS);
export const createDiscountCodeFail = createAction<IErrorType>(types.CREATE_DISCOUNT_CODE_FAIL);

export const updateDiscountCode = createAction<IUpdateDiscount>(types.UPDATE_DISCOUNT);
export const updateDiscountCodeSuccess = createAction<IReedemableCode>(types.UPDATE_DISCOUNT_SUCCESS);
export const updateDiscountCodeFail = createAction<IErrorType>(types.UPDATE_DISCOUNT_FAIL);

export const deleteDiscountCode = createAction<string>(types.DELETE_DISCOUNT);
export const deleteDiscountCodeSuccess = createAction<string>(types.DELETE_DISCOUNT_SUCCESS);
export const deleteDiscountCodeFail = createAction<IErrorType>(types.DELETE_DISCOUNT_FAIL);

export const cancelEvent = createAction<ICancelEvent>(types.CANCEL_EVENT);
export const cancelEventSuccess = createAction<any>(types.CANCEL_EVENT_SUCCESS);
export const cancelEventFail = createAction<string>(types.CANCEL_EVENT_FAIL);

export const getEventInviteDetails = createAction<IGetEventInviteDetails>(types.GET_EVENT_INVITE_DETAILS);
export const getEventInviteDetailsSuccess = createAction<any>(types.GET_EVENT_INVITE_DETAILS_SUCCESS);
export const getEventInviteDetailsFail = createAction<IErrorType>(types.GET_EVENT_INVITE_DETAILS_FAIL);

export const acceptEventInvite = createAction<IAcceptEventInvite>(types.ACCEPT_EVENT_INVITE);
export const acceptEventInviteSuccess = createAction<any>(types.ACCEPT_EVENT_INVITE_SUCCESS);
export const acceptEventInviteFail = createAction<IErrorType>(types.ACCEPT_EVENT_INVITE_FAIL);
